export class PaletteColorRule {
  constructor(light, main, dark, contrastText) {
    this.light = light                // A light variant of the primary color for highlight accents.
    this.main = main                  // The primary color of the application.
    this.dark = dark                  // A dark variant of the primary color for additional contrast.
    this.contrastText = contrastText  // The color of text when on components utilizing this color rule.
  }
}

export class TextColorRule {
  constructor(primary, secondary, disabled) {
    this.primary = primary      // The primary color for text elements. 
    this.secondary = secondary  // An alternate color for text elements for limited cases.
    this.disabled = disabled    // The color of text elements when disabled.
  }
}

export class BackgroundColorRule {
  constructor(paper, background) {
    this.paper = paper        // The background color for all container elements. 
    this.default = background // The background color which all elements rest upon.
  }
}